var login = require('./pages/Login')
var resetPassword = require('./pages/ResetPassword')
var parameters = require('./pages/Parameters')
var accounts = require('./pages/Accounts')
var labels = require('./pages/Labels')
var subscriptions = require('./pages/Subscriptions')
var services = require('./pages/Services')
var languages = require('./pages/Languages')
var sendsms = require('./pages/SendSMS')
var history = require('./pages/History')
var blank = require('./pages/Blank')

var component = function (comp, auth) {
  return {
    component: comp,
    auth: auth
  }
}

module.exports = {
  '/': component(blank, 'private'),
  '/admin': component(blank, 'private'),
  '/admin/login': component(login, 'public'),
  '/admin/reset/:token': component(resetPassword, 'public'),
  '/admin/parameters': component(parameters, 'private'),
  '/admin/labels': component(labels, 'private'),
  '/admin/accounts': component(accounts, 'private'),
  '/admin/subscriptions': component(subscriptions, 'private'),
  '/admin/services': component(services, 'private'),
  '/admin/languages': component(languages, 'private'),
  '/admin/sendSMS': component(sendsms, 'private'),
  '/admin/subscriptions/history/:id': component(history, 'private')
}



// WEBPACK FOOTER //
// ./src/admin/routes.js